import { BuiltCampaignControllerTrigger } from "src/shared/store/campaign-built/model/BuiltCampaignControllerTrigger";
export class BuiltCampaignControllerTriggerDataIntelligenceEvent extends BuiltCampaignControllerTrigger {
    constructor(response, context) {
        super(response, context);
        this.event_name = response.event_name;
    }
}
export const isBuiltCampaignControllerTriggerDataIntelligenceEvent = (trigger) => {
    return (trigger instanceof BuiltCampaignControllerTriggerDataIntelligenceEvent);
};
